import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { UserModal } from './UserModal';
import ShireTable from 'components/ShireTable';
import { CreateUser, User } from './UserType';
import { UserTableColumns } from './UserModel';
import axiosClient from 'services/axios';
import { disableUser, enableUser, fetchUsers, resetPassword } from 'services/UserService';
import { PaginationModel } from 'utils/PaginationType';
import { useConfirmDialog } from 'hooks/useConfirmDialog';

const UserManagement: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [paginationModel, setPaginationModel] = useState<PaginationModel>({ page: 0, pageSize: 5, rowCount: 0 });
  const [initialValues, setInitialValues] = useState<User | undefined>(undefined);
  const [isEdit, setIsEdit] = useState(false);
  const [users, setUsers] = useState<User[]>([]);
  const [total, setTotal] = useState(0);
  const [loadingTable, setLoadingTable] = useState(false);
  const { openConfirmDialog, closeConfirmDialog } = useConfirmDialog();

  useEffect(() => {
    getUsers(paginationModel.page, paginationModel.pageSize);
  }, [paginationModel.page, paginationModel.pageSize]);

  const getUsers = async (page: number, pageSize: number) => {
    setLoadingTable(true);
    const res = await fetchUsers(page, pageSize);
    setUsers(res.records);
    setTotal(res.total);
    setLoadingTable(false);
  };

  const handleEdit = (user: User) => {
    setInitialValues(user);
    setIsEdit(true);
    setOpen(true);
  };

  const handleSubmit = async (user: CreateUser) => {
    if (isEdit) {
      // update user
    } else {
      await axiosClient.post('/user', user);
      setOpen(false);
      setInitialValues(undefined);
      setIsEdit(false);
      getUsers(paginationModel.page, paginationModel.pageSize);
    }
  };

  const handleResetPassword = async (userId: number) => {
    openConfirmDialog({
      title: 'Đặt lại mật khẩu',
      content: 'Bạn có chắc chắn muốn đặt lại mật khẩu cho người dùng này?',
      handleOnOk: async () => {
        await resetPassword(userId);
        closeConfirmDialog();
      },
    });
  };

  const handleDisableUser = async (userId: number) => {
    openConfirmDialog({
      title: 'Vô hiệu hóa người dùng',
      content: 'Bạn có chắc chắn muốn vô hiệu hóa người dùng này?',
      handleOnOk: async () => {
        await disableUser(userId);
        closeConfirmDialog();
        await getUsers(paginationModel.page, paginationModel.pageSize);
      },
    });
  };

  const handleEnableUser = async (userId: number) => {
    openConfirmDialog({
      title: 'Mở khóa người dùng',
      content: 'Bạn có chắc chắn muốn mở khóa người dùng này?',
      handleOnOk: async () => {
        await enableUser(userId);
        closeConfirmDialog();
        await getUsers(paginationModel.page, paginationModel.pageSize);
      },
    });
  };

  return <>
  <Typography variant="h4" sx={{ marginBottom: 3 }}>Quản lý người dùng</Typography>
  <Paper elevation={3} sx={{ padding: 2 }}>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 2 }}>
    <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
      Thêm mới tài khoản
    </Button> 
  </Box>
  <ShireTable
    columns={UserTableColumns(getUsers, paginationModel, handleResetPassword, handleDisableUser, handleEnableUser)}
    rows={users}
    paginationModel={{
      page: paginationModel.page,
      pageSize: paginationModel.pageSize,
      rowCount: total,
    }}
    onPaginationModelChange={setPaginationModel}
    loading={loadingTable}
  />
  <UserModal
    open={open}
    onClose={() => {
      setOpen(false);
      setInitialValues(undefined);
      setIsEdit(false);
    }}
    onSubmit={handleSubmit} initialValues={initialValues} isEdit={isEdit} />
  </Paper>
  </>;
};

export default UserManagement; 